<template>
  <el-row>
    <table-template  @onDataFilter="onDataFilter" :queryParams="queryParams" actionUrl="/channel/findChannelBottomTabConfig.action"
                    ref="bottomTabConfigManagementTable">
      <template slot="search">
        温馨提示：仅支持对第2-4位的3个底部tab导航菜单进行开关/排序操作，首页和会员tab导航菜单不支持修改！
      </template>
      <template slot="item">
        <el-table-column
            label="名称"
            prop="name">

        </el-table-column>
        <el-table-column
            label="显示状态"
            >
        <template scope="scope">
          <el-switch
              style="display: block"
              v-model="scope.row.switch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="2"
              active-text="显示"
              inactive-text="隐藏"
              @change="changeSwitch(scope.$index,scope.row)"
             >
          </el-switch>
        </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <el-button  @click="upLayer(scope.$index,scope.row)">上移</el-button>
            <el-button  @click="downLayer(scope.$index,scope.row)" >下移 </el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import channelModel from '@/framework/models/channelModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'bottom-tab-config-management',
  data: function () {
    return {
      queryParams: {},
      data: [],
      channelId: null
    }
  },
  created () {
    let loginInfo = this.loginInfo
    this.channelId = loginInfo.id
  },
  methods: {
    changeSwitch (index, row) {
      var that = this
      var switchCount = 0

      for (var d in that.data) {

        if (that.data[d].switch === 1) {
          switchCount = switchCount + 1
        }

        if (row.switch === 1 && switchCount > 3) {
          that.$message({
            message: '最多开启3个',
            type: 'warning'
          })
          that.data[index].switch = 2
          row.switch = 2
          return
        }
      }

      that.data[index].switch = row.switch

      that.saveData(JSON.stringify(that.data))
    },
    upLayer (index, row) {
      var that = this
      if (index === 0) {
        that.$message({
          message: '处于顶端，不能继续上移',
          type: 'warning'
        })
      } else {
        let upDate = that.data[index - 1]
        that.data.splice(index - 1, 1)
        that.data.splice(index, 0, upDate)
      }

      that.saveData(JSON.stringify(that.data))
    },
    downLayer (index, row) {
      var that = this
      if (index + 1 === that.data.length) {
        that.$message({
          message: '处于末端端，不能继续下移',
          type: 'warning'
        })
      } else {
        let downDate = that.data[index + 1]
        that.data.splice(index + 1, 1)
        that.data.splice(index, 0, downDate)
      }
      that.saveData(JSON.stringify(that.data))
    },
    saveData: function (data) {
      let that = this
      let param = {
        bottomTabConfig: data,
        id: this.channelId
      }
      let listener = {
        success: function () {
          that.$message({
            type: 'success',
            message: '操作成功！ '
          })
          that.$refs.bottomTabConfigManagementTable.search()
        },
        error: function () {
          that.$message({
            type: 'error',
            message: '操作失败！ '
          })
        }
      }
      channelModel.updateChannelBottomTabConfig(that, param, listener)
    },
    onDataFilter: function (dataInfo) {
      this.data = dataInfo.data
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.bottomTabConfigManagementTable.search()
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
